/**
 * Change copy and icons for bag to cart. * https:www.notion.so/faire/Improving-the-1st-4th-order-experience-3e5c274ecfa54ca28823b17820b159f9
 */
export const CHANGE_BAG_TO_CART_COPY_AND_ICON_240719 = 'CHANGE_BAG_TO_CART_COPY_AND_ICON_240719';
